import BaseService from "./BaseService";

export default class ServicoService extends BaseService {

  constructor(self) {
    super(self);
  }

  ListarServicosAlunoAtivos(parameters) {
    return this.ExecutaFetch("/api/Servico/ListarServicosAlunoAtivos", "POST", parameters);
  }

  ListarServicosCancelados(parameters) {
    return this.ExecutaFetch("/api/Servico/ListarServicosCancelados", "POST", parameters);
  }

  ExcluirServicoAluno(parameters) {
    return this.ExecutaFetch("/api/Servico/ExcluirServicoAluno", "POST", parameters);
  }

  ListarTiposServico() {
    return this.ExecutaFetch("/api/Servico/ListarTiposServico", "GET");
    }

  GerarServicoUnico(parameters) {
    return this.ExecutaFetch("/api/Servico/GerarServicoUnico", "POST", parameters);
  }

  GerarServicoParcelado(parameters) {
    return this.ExecutaFetch("/api/Servico/GerarServicoParcelado", "POST", parameters);
  }
}